import { ArrowUpRight } from "lucide-react";
import { APP_URL, scrollToId } from "@/lib/site";

export const OpenAppButton = ({ testId, label = "Open the web app", className = "" }) => (
  <a
    href={APP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`group inline-flex items-center justify-center gap-2 rounded-full bg-grad px-6 py-3.5 text-sm font-semibold text-[#1a0b05] shadow-[0_10px_40px_-10px_rgba(255,106,61,0.7)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_18px_50px_-10px_rgba(255,106,61,0.9)] active:translate-y-0 ${className}`}
  >
    {label}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </a>
);

export const WaitlistButton = ({ testId, label = "Join the waitlist", className = "" }) => (
  <button
    type="button"
    onClick={() => scrollToId("waitlist")}
    data-testid={testId}
    className={`inline-flex items-center justify-center rounded-full border border-white/15 bg-white/[0.03] px-6 py-3.5 text-sm font-semibold text-[#f2f3f5] transition-[background-color,border-color] duration-300 hover:border-[#ff6a3d]/60 hover:bg-[#ff6a3d]/10 ${className}`}
  >
    {label}
  </button>
);
